import { Component, Input, Output, EventEmitter } from '@angular/core';
import {NzTableCellDirective, NzTableComponent, NzThMeasureDirective} from 'ng-zorro-antd/table';
import {NgForOf, NgIf} from '@angular/common';
import {TagComponent} from '../tag/tag.component';
import {NzIconDirective} from 'ng-zorro-antd/icon';
import {NzButtonComponent} from 'ng-zorro-antd/button';
import {FormsModule} from '@angular/forms';
import {NzInputDirective, NzInputGroupComponent} from 'ng-zorro-antd/input';
import {NzPaginationComponent} from "ng-zorro-antd/pagination";
import {PdfFacadeService} from '../../services/exportar/exportar-pdf/pdf-facade-sevice';
import {ReservaPdfService} from '../../services/reserva-pdf-service/reserva-pdf-service';

@Component({
  selector: 'app-reservas-table',
  templateUrl: './reservas-table.component.html',
    imports: [
        NzTableComponent,
        NgForOf,
        TagComponent,
        NzIconDirective,
        NzButtonComponent,
        FormsModule,
        NgIf,
        NzInputDirective,
        NzInputGroupComponent,
        NzThMeasureDirective,
        NzPaginationComponent,
    ],
  styleUrls: ['./reservas-table.component.css']
})
export class ReservasTableComponent {
  @Input() reservas: any[] = []; // Reservas obtenidas
  @Output() editReserva = new EventEmitter<any>(); // Para el evento de editar
  @Output() deleteReserva = new EventEmitter<any>(); // Para el evento de eliminar
  @Input() searchable: boolean = false;
  @Output() checkReserva = new EventEmitter<any>();
  @Input() showDeleteButton: boolean = true;
  @Input() showEditButton: boolean = true;

  searchTerm: string = '';
  startDate: string | null = null;
  endDate: string | null = null;
  pageSize: number = 7;
  pageIndex: number = 1;

  constructor(private reservaPdfService: ReservaPdfService) {}
  // Método para aplicar paginación
  private paginateData(data: any[]): any[] {
    const start = (this.pageIndex - 1) * this.pageSize;
    const end = this.pageIndex * this.pageSize;
    return data.slice(start, end);
  }

  // Método para manejar el cambio de página
  onPageChange(index: number): void {
    this.pageIndex = index;
  }

  get filteredData(): any[] {
    let filtered = this.reservas;

    if (this.searchTerm?.trim()) {
      const searchTermLower = this.searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item)
          .filter(value => value !== null && value !== undefined) // Filtra valores nulos o indefinidos
          .map(value => value.toString().toLowerCase()) // Convierte a string en minúsculas
          .some(value => value.includes(searchTermLower)) // Busca coincidencias
      );
    }

    if (this.startDate) {
      filtered = filtered.filter(item => new Date(item.fechaReserva) >= new Date(this.startDate!));
    }

    if (this.endDate) {
      filtered = filtered.filter(item => new Date(item.fechaReserva) <= new Date(this.endDate!));
    }

    return filtered;
  }

  // Los datos paginados deben basarse en los datos filtrados
  get paginatedData(): any[] {
    return this.paginateData(this.filteredData);
  }

  get length(): number {
    return this.filteredData.length; // Usamos los datos filtrados para obtener la longitud
  }

  // Métodos para emitir eventos
  onEdit(reserva: any): void {
    this.editReserva.emit(reserva);
  }

  onDelete(reserva: any): void {
    this.deleteReserva.emit(reserva);
  }

  getDniORuc(persona: any): string {
    // Mostrar el RUC si existe, de lo contrario el DNI
    return persona.ruc || persona.dni;
  }

  onCheck(reserva: any): void {
    this.checkReserva.emit(reserva); // Emitir reserva al componente padre
  }
  getRowNumber(index: number): number {
    return (this.pageIndex - 1) * this.pageSize + index + 1;
  }
  onDownloadPDF(reservaId: number): void {
    this.reservaPdfService.generateReservaPdf(reservaId);
  }
}

